import React from 'react';
import { Container, Nav } from 'react-bootstrap';

const VideoEmbed = () => {
	return (
		<section className="testimonial_bg md:py-[20px] py-[60px] bg-gray-50 relative">
			<Container>
				<div className="flex flex-col align-items-center justify-center max-w-3xl mx-auto">
					<p className="text-theme text-center mb-4 text-lg">
						Founder & Academy Director, Benny Lin's Interview regarding Li Na's semifinal win at the Australian Open.
					</p>
					<div>
						<iframe
							width="560"
							height="315"
							src="https://www.youtube.com/embed/0hg0HGdyM4Q?si=ZJTeqiWRFbdq6NgZ"
							title="YouTube video player"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							referrerPolicy="strict-origin-when-cross-origin"
							allowFullScreen
							className="aspect-video w-full"></iframe>
					</div>
				</div>
				<Nav.Link
					className="text-main text-center uppercase hover:underline hover:underline-offset-1 mt-4"
					href="https://www.youtube.com/watch?v=0hg0HGdyM4Q"
					target="_blank">
					Watch On YouTube
				</Nav.Link>
			</Container>
		</section>
	);
};

export default VideoEmbed;
